import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  loadItems: [],
  loading: false,
  error: null,
};

const loadSlice = createSlice({
  name: 'load',
  initialState,
  reducers: {
    setLoadStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    setLoadSuccess: (state, action) => {
      state.loadItems = action.payload;
      state.loading = false;
    },
    setLoadFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    }

  }
});

export const { setLoadStart, setLoadSuccess, setLoadFailure } = loadSlice.actions;
export default loadSlice.reducer;
